// test1645
(1645 && 0);
